<style>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="customer_PO" class="label"> {{ $t("customer_PO") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('customer_PO')"
                                    v-model="inputs.customer_po"
                                    :disabled="true"
                                />
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="company" class="label"> {{ $t("company") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('company')"
                                    v-model="inputs.company"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="irs" class="label"> {{ $t("irs") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('irs')"
                                    v-model="inputs.irs"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="address" class="label"> {{ $t("address") }}</label>
                                <app-input 
                                    type="textarea" 
                                    :placeholder="$t('address')"
                                    v-model="inputs.address"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="ship_to" class="label"> {{ $t("ship_to") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('ship_to')"
                                    v-model="inputs.ship_to"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="terms" class="label"> {{ $t("terms") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('terms')"
                                    v-model="inputs.terms"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="payment" class="label"> {{ $t("payment") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('payment')"
                                    v-model="inputs.payment"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="price" class="label"> {{ $t("price") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('price')"
                                    v-model="inputs.price"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="commision_broker" class="label"> {{ $t("commision_broker") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('commision_broker')"
                                    v-model="inputs.commission"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="palletized" class="label"> {{ $t("palletized") }}</label>
                                <app-input 
                                    type="text" 
                                    :placeholder="$t('palletized')"
                                    v-model="inputs.palletized"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="notes" class="label"> {{ $t("notes") }}</label>
                                <app-input 
                                    type="textarea" 
                                    :placeholder="$t('notes')"
                                    v-model="inputs.notes"
                                    :disabled="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="mt-5 col-md-3 action-buttons">
                        <button type="button" class="btn btn-primary mr-2  w-100" 
                            @click="redirectToShipping">
                            {{ $t('continue') }}
                        </button>
                    </div>
                </div> -->
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { get_data_customer } from '../mixins/api.js';

export default {
    name: "add_contractDetail_form",
    mixins: [FormMixin],
    data() {
        return {
            inputs: {
                customer_po : null,
                company : null,
                address : null,
                irs : null,
                ship_to : null,
                terms : null,
                payment : null,
                price : null,
                commission : null,
                palletized : null,
                notes : null,
            },
            preloader : false,
        }  
    },
    methods: {

        redirectToShipping(){
            this.$hub.$emit('change-tab-subtab', 'tab-4');
        },

        async loadData(id) {
            if (id) {
                const respuesta = await get_data_customer(id);
                this.inputs = { ...this.inputs, ...respuesta };
            }
            this.preloader = false;
        },
    },

    watch : {
        inputs : {
            deep : true,
            handler(newVal){

            }
        }
    },

    props: {
        props: { type: Object, default: () => ({}) }
    },

    mounted() {  
        this.contractId = this.props.id; 
        if (this.contractId) {
            this.preloader = true;
            this.loadData(this.contractId);
        }  
    },
}
</script>
